window.pmMochi = function (cvId, vidId, poster) {
  var mv = document.getElementById(vidId), mc = document.getElementById(cvId);
  if (!mv || !mc || mc.dataset.pm) return;
  mc.dataset.pm = '1';
  mv.muted = true;
  var S = 300, cx = mc.getContext('2d', { willReadFrequently: true }), ps = new Image();
  ps.src = poster;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var slow = navigator.connection && (navigator.connection.saveData || /2g|3g/.test(navigator.connection.effectiveType || ''));
  var bgm = new Uint8Array(S * S), stack = new Int32Array(S * S * 2);
  var lastT = -1, on = false, posterDone = false;
  function key() {
    var im = cx.getImageData(0, 0, S, S), d = im.data, sp = 0, x, y, p, i;
    bgm.fill(0);
    function nl(i) { var r = d[i], g = d[i + 1], b = d[i + 2]; return Math.abs(r - b) < 12 && Math.abs(r - g) < 10 && b > 120; }
    for (x = 0; x < S; x++) { stack[sp++] = x; stack[sp++] = (S - 1) * S + x; }
    for (y = 0; y < S; y++) { stack[sp++] = y * S; stack[sp++] = y * S + S - 1; }
    while (sp) {
      p = stack[--sp];
      if (bgm[p] || !nl(p * 4)) continue;
      bgm[p] = 1; x = p % S; y = (p / S) | 0;
      if (sp < stack.length - 4) {
        if (x > 0) stack[sp++] = p - 1;
        if (x < S - 1) stack[sp++] = p + 1;
        if (y > 0) stack[sp++] = p - S;
        if (y < S - 1) stack[sp++] = p + S;
      }
    }
    for (p = 0; p < S * S; p++) {
      i = p * 4;
      if (bgm[p]) { d[i + 3] = 0; continue; }
      x = p % S; y = (p / S) | 0;
      if (y > S * 0.92 && d[i] - d[i + 2] < 20) { d[i + 3] = 0; continue; }
      if ((x > 0 && bgm[p - 1]) || (x < S - 1 && bgm[p + 1]) || (y > 0 && bgm[p - S]) || (y < S - 1 && bgm[p + S])) d[i + 3] = 110;
    }
    cx.putImageData(im, 0, 0);
  }
  function draw() {
    var live = mv.readyState >= 2 && mv.videoWidth > 0;
    if (live && mv.currentTime !== lastT) {
      lastT = mv.currentTime;
      cx.clearRect(0, 0, S, S);
      cx.drawImage(mv, (mv.videoWidth - mv.videoHeight) / 2, 0, mv.videoHeight, mv.videoHeight, 0, 0, S, S);
      key();
    } else if (!live && !posterDone && ps.complete && ps.naturalWidth) {
      posterDone = true;
      cx.clearRect(0, 0, S, S);
      cx.drawImage(ps, 0, 0, S, S);
      key();
    }
    if (on) setTimeout(function () { requestAnimationFrame(draw); }, 33);
  }
  ps.onload = function () { if (!on) draw(); };
  if (!reduce && !slow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          if (!mv.src) { mv.src = mv.dataset.src; mv.preload = 'auto'; mv.load(); }
          mv.play().catch(function () {});
          on = true; draw();
        } else { mv.pause(); on = false; }
      });
    }, { rootMargin: '300px 0px' }).observe(mc);
  }
};
